import { colors } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const SubtitleWrapperStyled = styled.p`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0;
`;

export const HelpfulLinkStyled = styled.a`
  color: ${colors.blue[600]};
  font-weight: 700;
`;

export const SubtitleStyled = styled.span`
  margin-bottom: 3rem;
`;
